import NotificationActions from '../../actions/NotificationActions';
import RoutingActions from '../../actions/RoutingActions';
import PopupActions from '../../actions/PopupActions';

import UserStore from '../../stores/UserStore';
import DropdownProfile from '../profile/view/DropdownProfile.react';

import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as GuestListEndPoints } from '../../constants/GuestListConstants';

class CancelTransaction extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            cancelReasons: [],
            selectedCancelReason: '',
            isCancelling: false,
        };

        this.cancelCart = this.cancelCart.bind(this);
        this.getCancellationReasons = this.getCancellationReasons.bind(this);
    }

    componentDidMount() {
        this.getCancellationReasons();
    }

    getCancellationReasons() {
        AjaxPromises.POST(GuestListEndPoints.GET_CANCELLATION_REASONS, UserStore.getApiData()).then(res => {
            let options = [{title: 'Cancellation Reason', option: ''}];
            res.Data.forEach(x => options.push({title: x.Reason, option: x.Reason}));
            this.setState({ cancelReasons: options});
        });
    }

    cancelCart() {
        this.setState({ isCancelling: true }, () => {
            const guest               = this.props.guest;
            let formData            = UserStore.getApiData();
            formData.Guest_id       = guest.Guest_id;
            formData.ShipmentId     = guest.ShipmentId;
            formData.RegisterId     = UserStore.getState().selectedRegister.id;
            formData.ScheduleId     = guest.ScheduleId;
            formData.CancelReason = this.state.selectedCancelReason;

            AjaxPromises.POST(GuestListEndPoints.CANCEL_TRANSACTION,
                formData
            ).then(res => {
                this.setState({ isCancelling: false });
                if (!res.Result) {
                    NotificationActions.addNotification({
                        type   : 'error',
                        body   : res.Data[0].hasOwnProperty('Column1') ? res.Data[0].Column1 : res.Message
                    });
                } else {
                    NotificationActions.addNotification({
                        type   : 'success',
                        body   : 'Transaction cancelled'
                    });
                    PopupActions.close();
                    RoutingActions.updateRoute('guest-list');
                }
            });
        });
    }

    render() {
        var { guest } = this.props;
        var style = this.state.cancelReasons.length > 1 ? {'width' : '285px', 'height' : 'auto'} : {'width' : '285px', 'height' : '100px'};

        return (
            <div className='popup popup__transparent'>
                <div
                    className='popup__content'
                    style={style}>

                    <div className='popup-header'>
                        Cancel Transaction?

                        <div
                            className='popup-close'
                            onClick={PopupActions.close}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <button
                        className={`btn-green ${this.state.isCancelling ? 'btn-green__disabled' : ''}`}
                        disabled={this.state.isCancelling}
                        onClick={PopupActions.close}
                        style={{'width' : '110px', 'margin' : '10px 0 0 22px'}}>

                        NO
                    </button>

                    { !guest.IsPaid &&
                        <button
                            className={`btn-green ${this.state.isCancelling ? 'btn-green__disabled' : ''}`}
                            disabled={this.state.isCancelling}
                            onClick={() => { this.cancelCart(); }}
                            style={{'width' : '110px', 'margin' : '10px 0 0 22px'}}
                        >
                            {this.state.isCancelling ? <i className="fa fa-spinner fa-pulse" aria-hidden="true" /> : 'YES'}
                        </button>
                    }

                    {this.state.cancelReasons.length > 1 &&
                    <div style={{margin: '15px 5px'}}>
                        <DropdownProfile
                            options={this.state.cancelReasons}
                            selected={this.state.selectedCancelReason}
                            onChange={(field, selectedCancelReason) => { this.setState({ selectedCancelReason });}} />  
                    </div>    
                    }
                </div>
            </div>
        );
    }
}

export default CancelTransaction;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/CancelTransaction.react.jsx